import { httpRequest } from '../request';

export default {
  getSitemapData: () => httpRequest('GET:/api/public/sitemap', undefined, { errorMsg: false }),
};
